import _AnalyticsService from "../../services/analytics-service";

const AnalyticsService: IAnalyticsService = new _AnalyticsService();

export default AnalyticsService;
